// tslint:disable: interface-over-type-literal
import { Pipe, PipeTransform } from '@angular/core';

type OrderBy = { key: string, type?: string, by?: string };
import { AnyValues } from '../interfaces/undetermined';

@Pipe({ name: 'arrayMultisort' })
export class ArrayMultisortPipe implements PipeTransform {

  /* transform(): Pipe que ordena una matriz de acuerdo una o varias columnas de cada fila
    arr: Matriz que se ordenará
    options: Listado de columnas a ordenar, de mayor a menor importancia
      key: Propiedad a ordenar
      type: Orden alfabética o numéricamente
      by: Ordenar ascendente o descendentemente
  */
  transform(arr: AnyValues[], options: OrderBy[]): any[] {
    options.reverse().forEach((elm: OrderBy) => { arr = this.sort(arr, elm.key, elm.type, elm.by); });
    return arr;
  }

  /* sort(): Método que ordena los elementos de una matriz, de acuerdo a los valores de una propiedad seleccionada
    arr: Matriz que se ordenará
    key: Propiedad a ordenar
    type: Orden alfabética o numéricamente
    by: Ordenar ascendente o descendentemente
  */
  sort(arr: AnyValues[], key: string, type = "string", by = "ASC"): AnyValues[] {
    switch (type) {
      // ↓ Ordenar alfabéticamente
      case "string":
        // ↓ Devuelve la matriz ordenada alfabéticamente
        return arr.sort((previous: AnyValues, current: AnyValues) => {
          // ↓↓ prev, curr texto anterior y texto actual en mayúscula para encontrar ordenar sin importar la forma de la letra
          const prev: string = (previous[key] || "").toUpperCase();
          const curr: string = (current[key] || "").toUpperCase();
          // ↓ result: Verifica cual texto debe ir antes o después
          const result: number = prev < curr ? -1 : (prev > curr ? 1 : 0);
          // ↓ Devuelve el resultado para que la función sort ordene dependiendo de si se elige ordenar ascendente o descendentemente
          return by === "ASC" ? result : (result * -1);
        });
      // ↓ Ordenar numéricamente
      case "number":
        // ↓ Devuelve la matriz ordenada numéricamente dependiendo de si se elige ascendente o descendentemente
        return arr.sort((previous: AnyValues, current: AnyValues) => by === "ASC" ? (previous[key] - current[key]) : (current[key] - previous[key]));
      // ↓ Ordenar periodicamente
      case "date":
        // ↓ Devuelve la matriz ordenada periodicamente dependiendo de si se elige ascendente o descendentemente
        return arr.sort((previous: AnyValues, current: AnyValues) => by === "ASC" ?
          (new Date(previous[key], length <= 10 ? `${previous[key]} 00:00:00` : previous[key]).getTime() - new Date(current[key].length <= 10 ? `${current[key]} 00:00:00` : current[key]).getTime()) :
          (new Date(current[key].length <= 10 ? `${current[key]} 00:00:00` : current[key]).getTime() - new Date(previous[key], length <= 10 ? `${previous[key]} 00:00:00` : previous[key]).getTime()));
    }
  }

}
